export function setupCheckoutHelpers() {
    if(document.querySelector('.product-checkout-delivery')) {
        document.documentElement.classList.add('prevent-smooth');

        const shippingMethods = document.querySelectorAll('input[name="EcomCartShippingmethodID"]');

        Array.from(shippingMethods).forEach(method => {
            method.addEventListener('input', makeRequiredOnPicked);
        })
    }

    const backButtons = document.querySelectorAll('.checkout-back-button');

    if(backButtons) {
        Array.from(backButtons).forEach(btn => {
            btn.addEventListener('click', event => {
                event.preventDefault();

                const form = btn.closest('form');

                Array.from(document.querySelectorAll('input[required]')).forEach(input => {
                    input.required = false;
                })

                form.submit();
            })
        })
    }
}

function updatePrice(event) {
    const shippingPriceContainer = document.querySelector('.price-line__price');
    let shippingCurrency = shippingPriceContainer.getAttribute('data-currency');

    let newPrice = parseFloat(event.target.getAttribute('data-price'));

    shippingPriceContainer.setAttribute('data-price', newPrice);
    shippingPriceContainer.innerText = newPrice.toLocaleString('da-DK', {maximumFractionDigits: 2, minimumFractionDigits: 2}) + ' ' + shippingCurrency;

    updateTotalPrice();
}

function updateTotalPrice() {
    const totalPriceContainer = document.querySelector('.order-total');
    const currency = totalPriceContainer.getAttribute('data-currency');
    const priceLines = document.querySelectorAll('.product-checkout__price-wrapper .price-line__price:not(.order-total)');
    let price = 0;
    
    Array.from(priceLines).forEach(line => {
        const linePrice = parseFloat(line.getAttribute('data-price'));
        price = price + linePrice;
    });

    totalPriceContainer.innerText = price.toLocaleString('da-DK', {maximumFractionDigits: 2, minimumFractionDigits: 2}) + " " + currency;
}

function makeRequiredOnPicked(event) {
    if(event.target.value == "SHIP3") {
        const inputs = event.target.parentElement.querySelectorAll('[data-required="true"]');
        Array.from(inputs).forEach(input => {
            input.required = true;
        });
    } else {
        const inputs = document.getElementById('EcomCartShippingmethodID_SHIP3').parentElement.querySelectorAll('input');
        Array.from(inputs).forEach(input => {
            input.required = false;
        });
    }
}